import { render, staticRenderFns } from "./c-text-editable.vue?vue&type=template&id=2b480c52"
import script from "./c-text-editable.vue?vue&type=script&lang=js"
export * from "./c-text-editable.vue?vue&type=script&lang=js"
import style0 from "./c-text-editable.vue?vue&type=style&index=0&id=2b480c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports